<template>
<e-chart ref="chart" />
</template>

<script>
import {AXIS_LABEL, AXIS_LINE_STYLE, NUMBER_FONT_FAMILY} from './FactorCharts/chartStyle'
export default {
  name: 'OFPStackChart',
  props: {
    unit: {
      required: true,
      type: String
    },
    data: {
      required: true,
      type: Array
    },
    siteIopfDataMap: {
      required: true
    },
    factorMap: {
      required: true,
      type: Object
    },
    dataTime: {
      required: true,
      type: Array
    },
    siteName: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      color: [
        '#3ba272',
        '#F44336',
        '#7E57C2',
        '#29B6F6',
        '#26A69A',
        '#8BC34A',
        '#FFEE58',
        '#FF9800',
        '#607D8B',
        '#795548',
        '#EC407A',
        '#AB47BC',
        '#26C6DA',
        '#fe7300',
        '#66BB6A',
        '#D4E157',
        '#FFCA28'
      ]
    }
  },
  methods: {
    render (isReal) {
      let {unit, data, siteName, siteIopfDataMap, factorMap} = this
      let legendData = []
      if (siteIopfDataMap) {
        legendData = siteIopfDataMap.iofps.map(el => factorMap[el.factorId])
      }
      let dataTime = [...new Set(this.dataTime)]

      let chartOpt = {
        title: {
          text: siteName + ' - OFP堆积图'
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 10
        },
        legend: {
          type: 'scroll',
          width: 800,
          data: legendData
        },
        grid: [{
          top: 50,
          right: 20,
          bottom: 45,
          left: 20,
          containLabel: true
        }],
        tooltip: {
          trigger: 'item',
          formatter: function (param) {
            let {data, marker, value, seriesName} = param
            return `<div style="min-width: 200px;">
              <span style="display: inline-block; margin: 3px; font-weight: bold;">${seriesName}${data.isHaveIntegral ? '(重积分)' : ''}</span>
              <div style="display: flex;justify-content: space-between;align-items: center;padding: 2px;">
                <span>${marker}${data.dataTime}</span>
                <span><span style="font-weight: bold;">${value}</span>${data.unit}</span>
              </div>
            </div>`
          }
        },
        xAxis: {
          type: 'category',
          data: dataTime
        },
        yAxis: {
          name: unit,
          type: 'value',
          nameGap: 10,
          position: 'top',
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: NUMBER_FONT_FAMILY
          }
        },
        dataZoom: [{
          type: 'inside',
          start: dataTime.length <= 72 ? 0 : ((dataTime.length - 72) / dataTime.length * 100).toFixed(0),
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5
        }, {
          type: 'slider',
          start: dataTime.length <= 72 ? 0 : ((dataTime.length - 72) / dataTime.length * 100).toFixed(0),
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5,
          // height: 39,
          bottom: 9,
          left: 'center',
          handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '70%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 4,
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          },
          // dataBackground: {
          //   areaStyle: '#E4F0FF'
          // }
          fillerColor: 'rgba(228, 240, 255, .6)',
          borderColor: '#E4F0FF'
        }],
        color: this.color,
        series: data
      }

      this.$refs.chart.setOpt(chartOpt)
      this.$refs.chart.resize()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/OFPStackChart.vue